"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAbsoluteSitemapUrl = getAbsoluteSitemapUrl;
const origin_1 = require("./origin");
function getAbsoluteSitemapUrl() {
    return (0, origin_1.toAbsoluteUrl)(`/sitemap`);
}
//# sourceMappingURL=sitemap.js.map